
import React from 'react';
import { 
  Card, 
  CardContent, 
  CardFooter, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import TranslatedText from '@/TranslatedText';

interface GuideCardProps {
  title: React.ReactNode;
  description: React.ReactNode;
  icon: React.ReactNode;
  onClick?: () => void;
  href?: string;
}

const GuideCard = ({ title, description, icon, onClick, href }: GuideCardProps) => (
  <Card className="overflow-hidden h-full flex flex-col">
    <CardHeader className="flex flex-row items-center gap-4 pb-2">
      {icon}
      <div>
        <CardTitle>{title}</CardTitle>
      </div>
    </CardHeader>
    <CardContent className="flex-1">
      <p className="text-muted-foreground">{description}</p>
    </CardContent>
    <CardFooter>
      <Button 
        variant="ghost" 
        className="w-full"
        onClick={onClick}
        {...(href ? { as: 'a', href } : {})}
      >
        <TranslatedText text="Read Guide" />
      </Button>
    </CardFooter>
  </Card>
);

export default GuideCard;
